import Immutable from 'seamless-immutable';

import {
    INTEREST_LIST_REQUEST,
    INTEREST_LIST_SUCCESS,
    INTEREST_LIST_ERROR,
    INTEREST_LIST_UPDATE_FILTER,
} from 'Actions/interest';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    filter: {
        where: {},
        page: 1,
        includeCount: ['users'],
        order: 'title asc',
    },
    data: [],
    metadata: {},
});

export default function packListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case INTEREST_LIST_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case INTEREST_LIST_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                data: action.payload.data.map(item => {
                    return {
                        ...item,
                        link: 'Delete',
                    };
                }),
                metadata: action.payload.metadata,
            });

        case INTEREST_LIST_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        case INTEREST_LIST_UPDATE_FILTER:
            return state.merge({
                filter: state.filter.merge(action.payload),
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/interestsListReducer.js